@if (displayBilling) {
<div class="acc-ovv-financial-list">
  <div class="acc-overviewtabs position-relative">
    @if(isLoading) { 
    <!-- Loading spinner for Invoice -->
    <mat-progress-spinner class="spinner absolute top200" mode="indeterminate" diameter="100"></mat-progress-spinner>
    }
    <div class="row table-sanofi">

      <div class="col-md-3">
        <h3 class="financial">
          Billing
        </h3>
      </div>
    
      <div class="col-md-9 nav-alignment">
        <div class="prodCard-tabs tab_right_float">
          <ul class="prodCard-list">
            <li class="tab-link" [ngClass]="{ active: selectedTab === 'INVOICES' }" data-tab="tab_1"
              (click)="tabNavigation('INVOICES')">
              {{ "accountOverview.Financials.invoice_label" | cxTranslate }}
            </li>
            <li class="tab-link" [ngClass]="{ active: selectedTab === 'PAYMENTS' }" data-tab="tab_2"
              (click)="tabNavigation('PAYMENTS')">
              Payments
            </li>

            <li class="tab-link" [ngClass]="{ active: selectedTab === 'CREDITS' }" data-tab="tab_3"
              (click)="tabNavigation('CREDITS')">
              {{ "accountOverview.Financials.credits_label" | cxTranslate }}
            </li>
            <li class="tab-link" [ngClass]="{ active: selectedTab === 'STATEMENTS' }" data-tab="tab_4"
              (click)="tabNavigation('STATEMENTS')">
              {{ "accountOverview.Financials.statements_label" | cxTranslate }}
            </li>
          </ul>
        </div>
      </div>
      
    </div>
    @if (displayBilling) {
    <div id="tab_1" class="tab_content current">
      <div class="text-center no-invoices" *ngIf="
          !!paymentList &&
          paymentList?.length === 0 &&
          isLoadingDone &&
          selectedTab === 'INVOICES' && !isLoading
        ">
        You have no recent invoices
      </div>
      <div class="text-center no-credits" *ngIf="
          !!creditList &&
          creditList?.length === 0 &&
          isLoadingDone &&
          selectedTab === 'CREDITS'
        ">
        You have no recent credits
      </div>
      <div class="text-center no-credits" *ngIf="
          !!paymentHistoryList &&
          paymentHistoryList?.length === 0 &&
          selectedTab === 'PAYMENTS'">
        You have no recent payment
      </div>
      <div class="recent-invoice" *ngIf="selectedTab === 'INVOICES' && paymentList?.length > 0">
        <p>RECENT INVOICES</p>
      </div>
      <div class="recent-invoice" *ngIf="selectedTab === 'CREDITS' && creditList?.length > 0">
        <p>RECENT CREDITS</p>
      </div>
      <div class="row xls-pdf-invoice"
        *ngIf="showXlsPdf && isLoadingDone && selectedTab !== 'STATEMENTS' && selectedTab !== 'PAYMENTS'">
        <div class="col-md-12 ad-files-text darkblue full-wd">
          <a title="XLS" id="invoiceXLS" aria-label="download account overview invoices as" data-di-id="#invoiceXLS">
            <img src="../../assets/icons/excel_new.png" alt="" class="ad-pdf" target="_blank" />
            <span class="acc-icon-text" (click)="generateExcel()">{{
              "accountOverview.Financials.excel_label" | cxTranslate
              }}</span></a>&nbsp;
          <a id="invoicePDF" aria-label="download account overview invoices as" data-di-id="#invoicePDF">
            <img src="../../assets/icons/pdf.svg" alt="PDF" class="ad-pdf" />
            <span class="acc-icon-text" (click)="generatePDF()">{{
              "accountOverview.Financials.pdf_label" | cxTranslate
              }}</span>
          </a>
        </div>
      </div>
      <!-- Invoices -->
      <section class="row">
        <section class="col-md-12 col-xs-12 col-sm-12 fin-Table-Pad" id="invoice-table">
          <section class="payment-section" *ngIf="
              !!paymentList &&
              paymentList?.length > 0 &&
              isLoadingDone &&
              selectedTab === 'INVOICES'
            ">
            <table aria-describedby="invoicesTable" id="applyCreditsTable" class="payments-table table table-striped"
              [ngClass]="{ 'not-pdf': isPDF === false }">
              <thead>
                <tr>
                  <th scope="col" id="blineDate" (click)="sortColumn($event, 'blineDate', paymentList, 'Date')">
                    {{
                    "accountOverview.Financials.invoices.date_label"
                    | cxTranslate
                    }}
                    &nbsp;
                    <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
                  </th>
                  <th scope="col" id="dueDate" (click)="sortColumn($event, 'dueDate', paymentList, 'Date')">
                    {{
                    "accountOverview.Financials.invoices.due_date" | cxTranslate
                    }}
                    &nbsp;
                    <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
                  </th>
                  <th scope="col" id="customer" (click)="sortColumn($event, 'customer', paymentList, 'Number')">
                    Account #
                    &nbsp;
                    <i class="my-icon fas fa-caret-down"></i>
                  </th>
                  <th scope="col" id="refDocNo" (click)="sortColumn($event, 'refDocNo', paymentList, 'Number')">
                    {{
                    "accountOverview.Financials.invoices.invoice_no"
                    | cxTranslate
                    }}
                    &nbsp;
                    <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
                  </th>
                  <th scope="col" class="text-right" id="amount"
                    (click)="sortColumn($event, 'amount', paymentList, 'Number')">
                    Invoice amount
                    &nbsp;
                    <i class="my-icon fas fa-caret-down"></i>
                  </th>
                  <th scope="col" class="text-right" id="prompt_pay">
                    Prompt Pay discount
                    &nbsp;
                    <!-- <i class="my-icon fas fa-caret-down"></i> -->
                  </th>
                  <!-- <th scope="col" class="text-right" id="amount"
                    (click)="sortColumn($event, 'amount', paymentList, 'Number')">
                    {{
                    "accountOverview.Financials.invoices.invoice_amount"
                    | cxTranslate
                    }}
                    &nbsp;
                    <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
                  </th> -->
                  <th scope="col" class="text-right" id="amountDue"
                    (click)="sortColumn($event, 'amount', paymentList, 'Number')">
                    {{
                    "accountOverview.Financials.invoices.amount_due"
                    | cxTranslate
                    }}
                    &nbsp;
                    <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
                  </th>
                  <!-- <th scope="col">
                  </th> -->
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let data of paymentList; let i = index">
                  <tr *ngIf="data?.originalInvoice && data?.originalInvoice !== ''">
                    <td class="pay">{{ data?.blineDate }}</td>
                    <td class="pay">
                      <span [ngClass]="{
                        red: !!data?.dueDate && dateComparison(data?.dueDate)
                      }">{{ data?.dueDate }}
                        <!-- <ng-template #popSaveContent>
                        <span class="popover-content">{{
                          "makeAPayment.past_due_date" | cxTranslate
                          }}</span>
                      </ng-template>
                      <span [ngbPopover]="popSaveContent" triggers="manual" #p1="ngbPopover" placement="top"
                        (click)="toggle(p1)" container="body" popoverClass="popover-links-invoice"
                        *ngIf="!!data?.dueDate && dateComparison(data?.dueDate)">
                        <img src="assets/icons/warning_red.png" alt="warningIcon" class="warningIconEvent" />
                      </span> -->
                      </span>
                    </td>
                    <td class="pay">{{ data.customer }}</td>
                    <td class="pay">
                      <span *ngIf="data?.docType !=='DR' && data?.docType !=='DG' && data?.docType !=='DY' &&
                    data?.docType !=='DZ'">
                        <span *ngIf="asmStringCheck(data?.docNo); else notAsmUser">
                          {{data?.originalInvoice}}</span>
                        <ng-template #notAsmUser>
                          <a (click)='pdfOpen(data?.encryptedRefDocNo)'>{{data?.originalInvoice}}</a>
                        </ng-template>
                      </span>
                      <span *ngIf="data?.docType =='DR' || data?.docType =='DG' || data?.docType =='DY' ||
                    data?.docType =='DZ'">
                        {{data?.originalInvoice}}
                      </span>
                    </td>
                    <td class="pay text-right">{{ data?.amount | currency }}</td>
                    <td class="pay text-right">{{data?.discAmount | currency }}</td>
                    <!-- <td class="pay inv-text-end amount-Wrap">
                    {{ data?.amount | currency }}
                  </td> -->
                    <td class="pay inv-text-end amount-Wrap text-right AmtMinusDisc">
                      {{data?.paymentAmnt | currency}}
                      <!-- {{ data?.amount | currency }} -->
                    </td>
                    <!-- <td class="pay actions_dropdowns" [ngbPopover]="actionsPopup" placement="left" triggers="click"
                      #p1="ngbPopover">
                      <span><i class="dot-icon fas fa-ellipsis-h fa-lg"></i></span>
                    </td> -->
                    <!-- <ng-template #actionsPopup>
                    <ul class="drpdown">
                      <div class="dropdown_box">
                        <div class="dropdown_container">
                          <li class="issuedli"><a>Pay now</a></li>
                          <li class="issuedli"><a>Pay at terms</a></li>
                          <li class="issuedli"><a>View Invoice</a></li>
                        </div>
                      </div>
                    </ul>
                  </ng-template> -->
                  </tr>
                </ng-container>
              </tbody>
            </table>
            <table aria-describedby="invoicesTable" id="applyInvoiceRWD" class="payments-table table table-striped"
              [ngClass]="{ 'not-pdf': isPDF === false }">
              <tr class="sample-header">
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
              <ng-container *ngFor="let data of paymentList; let i = index">
                <tr *ngIf="data?.originalInvoice && data?.originalInvoice !== ''">
                  <td class="two-column-lay header">
                    {{
                    "accountOverview.Financials.invoices.date_label" | cxTranslate
                    }}
                  </td>
                  <td class="two-column-lay">{{ data?.blineDate }}</td>
                  <td class="two-column-lay header">
                    {{
                    "accountOverview.Financials.invoices.due_date" | cxTranslate
                    }}
                  </td>
                  <td class="two-column-lay">
                    <span [ngClass]="{
                      red: !!data?.dueDate && dateComparison(data?.dueDate)
                    }">{{ data?.dueDate }}
                      <!-- <ng-template #popSaveContent>
                      <span class="popover-content">{{
                        "makeAPayment.past_due_date" | cxTranslate
                        }}</span>
                    </ng-template>
                    <span [ngbPopover]="popSaveContent" triggers="manual" #p1="ngbPopover" placement="top"
                      (click)="toggle(p1)" container="body" popoverClass="popover-links-invoice"
                      *ngIf="!!data?.dueDate && dateComparison(data?.dueDate)">
                      <img src="assets/icons/warning_red.png" alt="warningIcon" class="warningIconEvent" />
                    </span> -->
                    </span>
                  </td>
                  <td class="two-column-lay header">
                    Account #
                  </td>
                  <td class="two-column-lay">{{ data.customer }}</td>
                  <td class="two-column-lay header">
                    {{
                    "accountOverview.Financials.invoices.invoice_no" | cxTranslate
                    }}
                  </td>
                  <td class="two-column-lay">
                    <span *ngIf="data?.docType !=='DR' && data?.docType !=='DG' && data?.docType !=='DY' &&
                  data?.docType !=='DZ'">
                      <span *ngIf="asmStringCheck(data?.docNo); else notAsmUser">
                        {{data?.originalInvoice}}</span>
                      <ng-template #notAsmUser>
                        <a (click)='pdfOpen(data?.encryptedRefDocNo)'>{{data?.originalInvoice}}</a>
                      </ng-template>
                    </span>
                    <span *ngIf="data?.docType =='DR' || data?.docType =='DG' || data?.docType =='DY' ||
                  data?.docType =='DZ'">
                      {{data?.originalInvoice}}
                    </span>
                  </td>
                  <td class="two-column-lay header">
                    Invoice amount
                  </td>
                  <td class="two-column-lay">{{ data?.amount | currency }}</td>
                  <td class="two-column-lay header">
                    Prompt Pay discount
                  </td>
                  <td class="two-column-lay">{{data?.discAmount | currency }}</td>
                  <!-- <td class="two-column-lay header">
                  {{
                    "accountOverview.Financials.invoices.invoice_amount"
                      | cxTranslate
                  }}
                </td>
                <td class="two-column-lay">{{ data?.amount | currency }}</td> -->
                  <td class="two-column-lay header">
                    {{
                    "accountOverview.Financials.invoices.amount_due" | cxTranslate
                    }}
                  </td>
                  <td class="two-column-lay">{{ data?.amount | currency }}</td>
                  <td class="two-column-lay header">
                  </td>
                  <td class="two-column-lay">
                    <!-- <a [routerLink]="['/my-account/invoices']" href="javascript: void(0);">
                    <span class="payment-checkbox-name">{{
                      "accountOverview.Financials.invoices.pay_now" | cxTranslate
                      }}</span></a> -->
                  </td>
                </tr>
              </ng-container>
            </table>
          </section>
        </section>
      </section>
      <section id="pdf-dummy" *ngIf="isPDF"></section>
      <!-- Credits -->
      <section *ngIf="
          !!creditList &&
          creditList?.length > 0 &&
          isLoadingDone &&
          selectedTab === 'CREDITS'
        " id="credits-table" class="credits-section">
        <table aria-describedby="creditsTable" id="applyCreditsTable" class="credits-table table table-striped"
          [ngClass]="{ 'not-pdf': isPDF === false }">
          <thead>
            <tr>
              <th scope="col" (click)="sortColumn($event, 'blineDate', creditList, 'Date')" id="creditDate">
                {{ "makeAPayment.credit_date" | cxTranslate }} &nbsp;
                <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
              </th>
              <th scope="col" id="creditNo" (click)="sortColumn($event, 'docNo', creditList, 'normal')">
                {{ "makeAPayment.credit#" | cxTranslate }}&nbsp;
                <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
              </th>
              <th scope="col" class="text-right" id="creditAmt"
                (click)="sortColumn($event, 'amount', creditList, 'Number')">
                {{ "makeAPayment.credit_amount" | cxTranslate }}
                <i class="my-icon fas fa-caret-down" *ngIf="!isPDF"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let data of creditList; let i = index">
              <td>
                {{ data?.blineDate }}
              </td>
              <td>
                <span *ngIf="data?.docType !=='DR' && data?.docType !=='DG' && data?.docType !=='DY' &&
                data?.docType !=='DZ'">
                  <span *ngIf="asmStringCheck(data?.docNo); else notAsmUser">
                    {{data?.refDocNo}}</span>
                  <ng-template #notAsmUser>
                    <a (click)='pdfOpen(data?.encryptedRefDocNo)'>{{data?.refDocNo}}</a>
                  </ng-template>
                </span>
                <span *ngIf="data?.docType =='DR' || data?.docType =='DG' || data?.docType =='DY' ||
                data?.docType =='DZ'">
                  {{data?.refDocNo}}
                </span>
              </td>
              <td class="text-right">({{ data?.amount | currency }})</td>
            </tr>
          </tbody>
        </table>
        <table aria-describedby="creditsTable" id="applyCreditsRWD" class="credits-table table table-striped"
          [ngClass]="{ 'not-pdf': isPDF === false }">
          <tr class="sample-header">
            <th scope="col"></th>
            <th scope="col"></th>
          </tr>
          <tr *ngFor="let data of creditList; let i = index">
            <td class="two-column-lay header">
              {{ "makeAPayment.credit_date" | cxTranslate }}
            </td>
            <td class="two-column-lay">{{ data?.blineDate }}</td>
            <td class="two-column-lay header">
              {{ "makeAPayment.credit#" | cxTranslate }}
            </td>
            <td class="two-column-lay">
              <span *ngIf="data?.docType !=='DR' && data?.docType !=='DG' && data?.docType !=='DY' &&
              data?.docType !=='DZ'">
                <span *ngIf="asmStringCheck(data?.docNo); else notAsmUser">
                  {{data?.refDocNo}}</span>
                <ng-template #notAsmUser>
                  <a (click)='pdfOpen(data?.encryptedRefDocNo)'>{{data?.refDocNo}}</a>
                </ng-template>
              </span>
              <span *ngIf="data?.docType =='DR' || data?.docType =='DG' || data?.docType =='DY' ||
              data?.docType =='DZ'">
                {{data?.refDocNo}}
              </span>
            </td>
            <td class="two-column-lay header">
              {{ "makeAPayment.credit_amount" | cxTranslate }}
            </td>
            <td class="two-column-lay text-left">
              ({{ data?.amount | currency }})
            </td>
          </tr>
        </table>
      </section>
      <!-- Statements -->
      <section class="statements" *ngIf="selectedTab === 'STATEMENTS'">
        <!-- <div class="row">
          <div class="col-sm-5 offset-sm-7 d-flex justify-content-end">
            RECENT STATEMENTS
          </div>
        </div> -->
        <app-open-statements [hideAside]="removeAside" [restrictToTen]="true"></app-open-statements>
      </section>
      <!-- Payments -->
      <section class="row">
        <section class="col-md-12 col-xs-12 col-sm-12 fin-Table-Pad" id="invoice-table">
          <section class="payment-section" *ngIf="selectedTab === 'PAYMENTS' && !!paymentHistoryList &&
          paymentHistoryList?.length > 0">
            <table aria-describedby="invoicesTable" id="applyCreditsTable" class="payments-table table table-striped"
              [ngClass]="{ 'not-pdf': isPDF === false }">
              <thead>
                <tr>
                  <th scope="col" id="dueDate" (click)="sortColumn($event, 'dueDate', paymentHistoryList, 'Date')">
                    Due date
                    &nbsp;
                    <i class="my-icon fas fa-caret-down"></i>
                  </th>
                  <th scope="col" id="paymentDate"
                    (click)="sortColumn($event, 'paymentDate', paymentHistoryList, 'Date')">
                    Date paid
                    &nbsp;
                    <i class="my-icon fas fa-caret-down"></i>
                  </th>
                  <th scope="col" id="accountNo">
                    Account #
                    &nbsp;
                  </th>
                  <th scope="col" id="invoiceNo" (click)="sortColumn($event, 'invoiceNo', paymentHistoryList, 'Number')">
                    Invoice #
                    &nbsp;
                    <i class="my-icon fas fa-caret-down"></i>
                  </th>
                  <th scope="col" id="invoice_amount">
                    Method
                    &nbsp;
                  </th>
                  <th scope="col" id="invoiceAmount"
                    (click)="sortColumn($event, 'invoiceAmount', paymentHistoryList, 'Number')"> Amount &nbsp;
                    <i class="my-icon fas fa-caret-down"></i>
                  </th>
                  <th scope="col" id="amountDue">
                    Balance
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of paymentHistoryList; let i = index">
                  <td class="pay">{{data?.dueDate}}</td>
                  <td class="pay">{{data?.paymentDate}}</td>
                  <td class="pay">{{data?.accountNumber}}</td>
                  <td class="pay">
                    <span *ngIf="asmStringCheck(data?.invoiceNo); else notAsmUser">
                      {{data?.invoiceNo}}</span>
                    <ng-template #notAsmUser>
                      <a (click)='pdfOpen(data?.encryptedInvoiceNumber)'>{{data?.invoiceNo}}</a>
                    </ng-template>
                  </td>
                  <td class="pay">{{data?.paymentMethod}}</td>
                  <td class="pay text-right">{{data?.invoiceAmount}}</td>
                  <td class="pay inv-text-end amount-Wrap text-right">
                    {{data?.invoiceBalance}}
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </section>
      </section>
      <!-- Buttons -->
      <div class="invoice-btngrps" *ngIf="
          !!paymentList &&
          paymentList?.length > 0 &&
          isLoadingDone &&
          selectedTab === 'INVOICES'
        ">
        <button type="button" class="btn-primary" data-di-id="di-id-41a05d18-6b04a424" (click)="redirectClick('Invoice')"
          [routerLink]="['/my-account/invoices']">
          View all open invoices
        </button>
      </div>
      <div class="invoice-btngrps"
        *ngIf="!!paymentHistoryList && paymentHistoryList.length > 0 && selectedTab === 'PAYMENTS'">
        <button type="button" class="btn-primary btnpaymentinvoicecredit" data-di-id="di-id-41a05d18-6b04a424"
          [routerLink]="['/my-account/paymenthistory']">
          View payment history
        </button>
      </div>
      <div class="invoice-btngrps" *ngIf="
          !!creditList &&
          creditList?.length > 0 &&
          isLoadingDone &&
          selectedTab === 'CREDITS'
        ">
        <button type="button" class="btn-primary" data-di-id="di-id-41a05d18-6b04a424"
          [routerLink]="['/my-account/invoices']" (click)="redirectClick('Credit')">
          {{ "accountOverview.Financials.credits.credit_btn_txt" | cxTranslate }}
        </button>
      </div>
      <!-- <div class="invoice-btngrps" *ngIf="selectedTab === 'STATEMENTS'">
        <button type="button" class="btn-primary" data-di-id="di-id-41a05d18-6b04a424"
          [routerLink]="['/my-account/statements']">
          {{
          "accountOverview.Financials.statements.statement_btn_txt"
          | cxTranslate
          }}
        </button>
      </div> -->
    </div>
    }
  </div>
  <ng-template #invoicePastDueDateMsg>{{
    "accountOverview.Financials.pdf_label" | cxTranslate
    }}</ng-template>
  <div class="hide-section" *ngIf="isPDF">
    <div class="col-md-12" id="pdf-header">
      <h3 class="financial">
        {{ "accountOverview.Financials.label" | cxTranslate }}
      </h3>
    </div>
    <div class="col-md-12" id="pdf-subheader">
      <h3 class="sub-label-pdf" *ngIf="selectedTab === 'INVOICES'">
        {{ "accountOverview.Financials.invoice_label" | cxTranslate }}
      </h3>
      <h3 class="sub-label-pdf" *ngIf="selectedTab === 'CREDITS'">
        {{ "accountOverview.Financials.credits_label" | cxTranslate }}
      </h3>
    </div>
    <div class="line-top-sanofi-pdf" id="line-sanofi"></div>
  </div>
</div>
}